// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
    <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1, color: 'rgba(26, 90, 132, 60%)' }} />
);


const navConfig = [
    {
        title: 'Dashboard',
        path: '/dashboard/app',
        icon: icon('ic_analytics'),
        name: 'View-Dashboard',
    },
    // {
    //     title: 'Users Management',
    //     icon: icon('users-management'),
    //     name: 'View-Users-Management',
    //     submenu: [
    //         {
    //             title: 'Users',
    //             path: '/dashboard/users',
    //             icon: icon('ic_user'),
    //             name: 'View-Users',
    //         },
    //         {
    //             title: 'Roles',
    //             path: '/dashboard/roles',
    //             icon: icon('roles-permission'),
    //             name: 'View-Role',
    //         },
    //     ],
    //     },

    {
        title: 'loan Requests',
        path: '/dashboard/loan-request',
        icon: icon('loan'),
        name: 'View-Notification',
    },
    {
        title: 'Lenders',
        path: '/dashboard/lenders',
        icon: icon('lender'),
        name: 'View-Notification',
    },
    {
        title: 'Borrowers',
        path: '/dashboard/borrower',
        icon: icon('borrowers'),
        name: 'View-Notification',
    },
       {
        title: 'Brokers',
        path: '/dashboard/broker',
        icon: icon('broker'),
        name: 'View-Notification',
    },
    {
        title: 'Investors',
        path: '/dashboard/investors',
        icon: icon('plans'),
        name: 'View-Notification',
    },
    {
        title: 'Insurance Providers',
        path: '/dashboard/insurance-providers',
        icon: icon('ic_lock'),
        name: 'View-Notification',
    },
    {
        title: 'States',
        path: '/dashboard/states',
        icon: icon('state'),
        name: 'View-Notification',
    },
    // {
    //     title: 'Blogs',
    //     path: '/dashboard/blogs',
    //     icon: icon('blogs'),
    //     name: 'View-Notification',
    // },
    {
        title: 'Payments',
        path: '/dashboard/payment',
        icon: icon('payment'),
        name: 'View-Notification',
    },
    {
        title: 'NewsLetters',
        path: '/dashboard/newsletter',
        icon: icon('newsletter'),
        name: 'View-Notification',
    },
    //    {
    //     title: 'Alert',
    //     path: '/dashboard/alert',
    //     icon: icon('warning-alert'),
    //     name: 'View-Notification',
    // },
    // {
    //     title: 'Integration',
    //     path: '/dashboard/integration',
    //     icon: icon('integration'),
    //     name: 'View-Integration',
    // },
    // {
    //     title: 'Log History',
    //     path: '/dashboard/logs',
    //     icon: icon('list'),
    //     name: 'View-Notification',
    // },
    // {
    //     title: 'Setting',
    //     path: '/dashboard/setting',
    //     icon: icon('settings'),
    //     name: 'Create-Settings',
    // },
];

export default navConfig;
